import { Color } from "@bonliva-crm/ui";
import { WithTooltip } from "@common";
import { Info } from "@material-ui/icons";

export function LabelWithInfo({
  label,
  info
}: {
  label: React.ReactNode;
  info: React.ReactNode;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {label}
      <WithTooltip placement={"top"} title={info}>
        <Info style={{ marginLeft: 5, color: Color.DarkGray }} fontSize="small" />
      </WithTooltip>
    </div>
  );
}
